<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.99219 36.001V20.001V20.651V12.001V36.001ZM35.7922 41.001L28.7922 34.001C28.3589 33.5676 28.0505 33.101 27.8672 32.601C27.6839 32.101 27.5922 31.601 27.5922 31.101C27.5922 30.0343 27.9755 29.0843 28.7422 28.251C29.5089 27.4176 30.4922 27.001 31.6922 27.001C32.6255 27.001 33.3589 27.2176 33.8922 27.651C34.4255 28.0843 35.0589 28.6676 35.7922 29.401C36.4589 28.7343 37.0672 28.1676 37.6172 27.701C38.1672 27.2343 38.9255 27.001 39.8922 27.001C41.1255 27.001 42.1172 27.426 42.8672 28.276C43.6172 29.126 43.9922 30.0843 43.9922 31.151C43.9922 31.651 43.8922 32.151 43.6922 32.651C43.4922 33.151 43.1922 33.601 42.7922 34.001L35.7922 41.001ZM7.99219 16.001H39.9922V12.001H7.99219V16.001ZM23.1422 40.001H7.99219C6.89219 40.001 5.95052 39.6093 5.16719 38.826C4.38385 38.0426 3.99219 37.101 3.99219 36.001V12.001C3.99219 10.901 4.38385 9.95931 5.16719 9.17598C5.95052 8.39264 6.89219 8.00098 7.99219 8.00098H39.9922C41.0922 8.00098 42.0339 8.39264 42.8172 9.17598C43.6005 9.95931 43.9922 10.901 43.9922 12.001V22.651C42.8255 21.8176 41.5505 21.1676 40.1672 20.701C38.7838 20.2343 37.3255 20.001 35.7922 20.001C33.8922 20.001 32.1005 20.3593 30.4172 21.076C28.7339 21.7926 27.2589 22.7676 25.9922 24.001H7.99219V36.001H21.9422C22.0422 36.701 22.1922 37.3843 22.3922 38.051C22.5922 38.7176 22.8422 39.3676 23.1422 40.001Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
